import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

const ModuleListItemDiv = styled.div((props) => props.$styleText);

export const ModuleListItem = (componentProps) => {
  let props = componentProps;

  const dataElementContext = React.useContext(DataElementContext);
  let isVisible = true;

  [props, isVisible] = processComponentProps(props, dataElementContext);

  if (!isVisible) {
    return null;
  }

  return (
    <ModuleListItemDiv className={props.className ?? ''} $styleText={props.styleText} style={props.style}>
      {componentProps.children}
    </ModuleListItemDiv>
  );
};
